var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 440.2",
    style: {
      enableBackground: "new 0 0 406 440.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.online0{fill:#25002E;}\n\t.online1{fill:#F0ACAE;}\n\t.online2{fill:#FDCBC7;}\n\t.online3{fill:#7E4800;}\n\t.online4{fill:#460052;}\n\t.online5{fill:#18001E;}\n\t.online6{fill:#D4E3FF;}\n\t.online7{fill:#731586;}\n\t.online8{fill:#FAEBEA;}\n\t.online9{fill:#39003C;}\n\t.online10{fill:#E49195;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "406,273.8 355.7,345.7 355.7,345.7 314.9,404 307,405.4 250.9,415.3 158.3,431.7 156.6,430.5 133.9,414.6  132.6,413.6 102.9,392.9 97.6,389.2 97.5,389.1 80,376.9 76.2,374.2 71.2,370.7 59.5,362.5 58.8,362 39.9,348.8 36.7,346.5  33.4,344.3 28.1,340.5 0.4,184 91.6,53.7 133,46.4 148.4,43.7 157.1,42.2 157.1,42.2 192.8,35.8 220,31 244,26.8 248.1,26.1  264.3,37.4 270.8,42 279.9,48.3 378.4,117.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "perso"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "102.9,392.9 97.6,389.2 97.5,389.2 97.5,389.1 80,376.9 76.2,374.2 97.5,360.2 98.2,364.4  98.2,364.4 101.5,384.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "133.9,414.6 132.6,413.6 102.9,392.9 97.6,389.2 97.5,389.2 97.5,360.2 115.6,351.8 126.3,375.4  126.3,375.4 131,385.8 133.6,413.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "online2",
    d: "M115.6,351.8L115.6,351.8l-17.3,12.7l0,0l-0.7,0.5l-12.6,9.2l-4.9,2.7l-3.8-2.6l-5.1-3.5l-11.7-8.2l-0.7,0 l0-0.4l-18.9-13.2l-3.2-2.3l21-15.8c0,0,45.3,1.6,45.3,2.4c0,0.3,1.4,2.4,3.2,5.1C109.8,343.6,115.2,351.3,115.6,351.8 L115.6,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "online1",
    d: "M115.6,351.8l-17.3,12.7l0,0l-0.7,0.5l-12.6,9.2l-4.9,2.7l-3.8-2.6l-5.1-3.5l26.5-21.3l0.7-9l0.5-6.4l7.3,4.3 C109.8,343.6,115.2,351.3,115.6,351.8L115.6,351.8L115.6,351.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online3",
    points: "175.8,198.7 194.3,159.7 198,153.4 190.3,140.5 198,127.7 192.9,117.2 196.7,105.1 203.2,93  201.2,80 200.8,52.3 194.7,36.8 174.5,27.2 160.7,30.5 147.4,32.5 134.9,40.4 125.2,71.3 119.1,82.2 124.6,97.8 109.8,123.9  107.8,138.5 100.5,148.8 100.5,158.5 104.5,163.1 104.1,167.2 99.3,169.4 99.3,176.5 115.3,187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online4",
    points: "169.5,221 155.5,249.1 157.1,277.4 168.4,302.2 168.4,325.4 157.1,347.7 158.6,399.9 158.3,431.7  156.6,430.5 133.9,414.6 132.6,413.6 131,385.8 126.3,375.4 126.3,375.4 115.6,351.8 115.6,351.8 98.4,340.4 95.6,338.6 59,337.8  39.9,348.8 36.7,346.5 33.4,344.3 59.2,318.9 90.5,294.4 93.1,273.3 93.8,267.1 93.8,253.3 92.4,239.9 91.9,234.8 91.6,232.1  130.1,189.9 136.6,182.7 162.4,180.7 167.9,180.3 169.8,185.2 175,198.6 175.4,199.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "online0",
    d: "M90.5,294.4c0,0,20-10.2,21-10.5s25.1-8.6,25.1-8.6l-34,4.9l-8.6,3l-0.9-9.7L90.5,294.4L90.5,294.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "169.5,221 155.5,249.1 157.1,277.4 168.4,302.2 168.4,325.4 157.1,347.7 158.5,411.1 154.5,346.7  164.4,318.2 157.5,299 140.1,270.7 139.5,238.1 157.5,212.1 143.1,212.1 123.8,222.9 112.6,241.5 100.7,248.1 93.8,260.4  93.8,253.3 91.6,232.1 136.6,182.7 162.4,180.7 169.8,185.1 175.4,199.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online4",
    points: "126.9,161.7 102.1,175.5 90.5,189.6 90.5,195.1 97.7,210  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online2",
    points: "87.2,214.4 87.2,208.3 90,207.3 92.3,206.7 92.3,200.3 94.8,197.4 97.2,197.4 98.3,191.1  101.6,189.6 105.7,193.6 90.8,213.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "84.9,240 93.8,253.3 96.9,244.4 110.4,235.9 110.4,220.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online5",
    points: "309.2,400.2 307,405.4 250.9,415.3 249.3,408.8 251.4,401.8 243.6,395.9 245.3,384.6 241.7,359.4  241.2,355.7 246.1,349.4 248,347 252,341.8 258.9,333 266.7,322.9 277.3,309.2 288.1,295.3 308.4,353.6 308.7,392.9 308.7,392.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "355.7,345.7 355.7,345.7 314.9,404 307,405.4 309.2,400.2 317.5,398.3 308.7,392.9 308.7,392.9  304.9,390.5 248.2,353.6 248,347 247.9,345.3 247.5,335.1 246.6,315.1 255.2,300 264.5,283.7 286.7,244.6 304.7,246.5  309.4,253.6 307,260 309.4,268.6 308.1,274 318.1,287 317,294 324.8,307.7 324.8,311 346.9,332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online6",
    points: "266,117.4 277.1,141.4 296.4,191.1 304.7,231.6 304.7,246.5 278.9,243.8 255.2,133.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online4",
    points: "220,47.4 219.1,35.5 222.8,17.9 241.2,6 255,5 268.8,9.6 276.2,18.9 255.2,51.6 235.6,54.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "224.6,58.5 223.7,78.7 232.9,81.5 262.4,100.8 266,81.5 232,53.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online2",
    points: "279.9,27.4 279.9,60.3 270.4,87 253.1,87 234.7,75 232,60 228.3,64.9 221.8,61.2 219.1,45.6  224.6,41.9 236.6,49.2 232.9,39.1 244.9,31.8 242.1,16.1 276.2,18.9 277.8,22.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online6",
    points: "223.7,78.7 220,81.5 232,86.1 247.6,100.8 265.1,127.6 270.6,105.4 262.4,100.8 232.9,81.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "online4",
    points: "291.8,205.8 284.5,261.1 266,304 241.2,360.6 195.1,365.2 195.9,353.6 199.7,295.2 195.1,220.7  188.7,141.4 196,114.7 213.5,98.1 220,81.5 232,86.1 247.6,100.8 265.1,127.6 281.7,163.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "241.2,360.6 195.9,353.6 195.1,365.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "265.1,127.6 238.4,99 220,94.8 203.4,115.6 220,148.9 213.5,243.6 195.9,353.6 199.7,295.2  195.1,220.7 188.7,141.4 196,114.7 213.5,98.1 220,81.5 232,86.1 247.6,100.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "236.6,169 229.2,135.8 255.2,160.8 247.6,187.4 246.7,213.2 262.4,167.2 260.5,196.6 251.3,237.2  255.9,281.4 232,251 228.3,175.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "273.4,178.2 267.9,205.8 260.5,228.9 273.4,206.9 278.9,186.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "279.9,27.4 279.9,60.3 270.4,87 265,87 267.9,83.3 271.6,72.3 271.6,62.2 275.3,56.6 272.5,50.2  270.6,41.2 277.6,38.4 277.1,31.8 277.8,22.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online4",
    points: "280,314.5 244.9,336.7 220,287.8 196.3,240.5 188.7,182 186.8,138.6 193.9,122.2 212.6,112.8  228.3,127.6 241.2,158.8 242.8,217.5 254,263 274.6,303.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online7",
    points: "280,314.5 244.9,336.7 220,287.8 196.3,240.5 188.7,182 186.8,138.6 193.9,122.2 212.6,112.8  228.3,127.6 214.5,121.1 204,127.6 197,157.9 201.6,200.3 211.7,194.8 203.4,212.6 203.4,227 218.1,219.8 207.1,239.9  226.9,281.4 257.8,301.6 274.6,303.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online0",
    points: "263.3,281.4 237.5,264.8 220,235.2 240.2,258.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online2",
    points: "285.4,329.3 285.4,351.3 288.6,373.9 283.3,374.4 281.7,372 277.3,349.5 274.8,353.6 270.6,356  267.3,353.6 263.3,353.6 260.5,349.5 255.2,349.5 252.2,344.9 251.6,336.2 251.4,332.6 279,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "285.4,329.3 285.4,351.3 284.1,343.5 280.7,329 271.1,327.5 251.6,336.2 251.4,332.6 279,315.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "285.4,329.3 302.3,360.6 299.6,363.7 294.7,361.9 285.4,342.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online2",
    points: "187,162.8 175.4,199.7 167.9,195.4 153.1,196.5 143.1,190.3 91.9,240.4 75.2,241.5 70.8,228  76.8,218.1 76.8,218.1 88.1,212.9 133.2,146.4 136.4,141.8 143.1,136.6 144.4,115.6 141.9,100.4 141.7,99.4 143.4,99.2 179.5,93  173.8,106.7 173.3,126.1 183.3,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online8",
    points: "155.8,148.2 149.3,162.2 92.7,221.3 81.3,222.9 76.8,218.1 76.8,218.1 88.1,212.9 133.2,146.4  142,142.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "167.9,195.4 153.1,196.5 143.1,190.3 153.6,182.7 152,190.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online1",
    points: "179.5,93 173.8,106.7 173.3,126.1 167.9,116.9 173,102.4 164.7,113.7 144.4,115.6 141.9,100.4  143.4,99.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "online2",
    points: "160.9,42.5 150.4,41.5 136.1,57.7 134.7,62.2 134.7,70.6 130.4,75.7 130.4,102.9 141.8,105.1  165.7,105.1 174.6,95.7 182.4,94.3 190.3,84.3 187.9,76.5 184.1,76.5 176.5,79.5 176.2,66 170.9,59.8 172.2,55.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    className: "online9",
    d: "M84.1,341.6l-4.9-1.9l-10.3,5.4l-12,3l-0.2,3.4l6.2-1.3l-6.5,4.8l0.9,2.7l2.7,0.1l1.1-0.8 l-2,2.6l-0.1,0.2l-0.1,2.1l0,0.4l0.7,0l2.3,0.1l6.2-5.9l-0.2,1.3l8,3.7l0.1,0.9l5.6-3.8l2.2-4.9l0.1-0.1l0.2-4.7l1.8-2.4 L84.1,341.6L84.1,341.6z M75.7,357.6l-2.4-1l0.1-2.4l2-1.7l2,0.6l0.3,3.1L75.7,357.6L75.7,357.6z M82.6,348.7l-0.3,4.8l-2,4.5 l-3.5,2.4l-0.2-1.9l2.3-1.7l-0.4-4.7l-3.5-1l-2.9,2.5l-0.2,3.9l3.2,1.4l-0.1,1.3l-5.9-2.7l0.9-5.8l-1.3-0.2l-0.5,3.4l0,0l-7,6.6 l-1.2-0.1l0-0.9l6.8-8.7l-1-0.8l-2.3,2.9l-4.1,2.8l-1.5-0.1l-0.3-1l8.1-5.9l-0.5-1.1L58,350l0-0.8l11.2-2.8l0.1,0l9.9-5.2 l3.8,1.4l1.1,3.9L82.6,348.7L82.6,348.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "online10",
    points: "126.3,375.4 126.3,375.4 122.1,373.1 111,373.1 101.5,384.5 97.6,389.2 97.5,389.2 97.5,365  98.2,364.4 98.2,364.4 115.6,351.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.31b9daadfdfd9ea87df9cd63312b5b1b.svg";
export { ForwardRef as ReactComponent };